/**************************************************
 * Nombre:       Footer
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid, Link, Stack, Typography} from "@mui/material";
import {theme} from "../Tema";
import logo_barra from '../Recursos/logo_redondo.png'
import {useContext, useState} from "react";

import {useNavigate} from "react-router-dom";
import Tarjeta_Categoria_Footer from "./Tarjetas/Tarjeta_Categoria_Footer";
import {contexData} from "../App";
import {NUMEROATENCION, REDES} from "../Constantes";
import {irUrl} from "../Utilidades/irUrl";
import {iniciarChatWass} from "../Utilidades/iniciarChatWass";
import {useResponsive} from "../Modulo_Responsive/Hooks/useResponsive";


const Footer = () => {
    const cData = useContext(contexData)
    const {sCell} = useResponsive()
    const navigate = useNavigate()
    const [seleccionado, setSeleccionado] = useState('')


    return (
        <Grid
            container
            justifyContent="center"
            alignItems="center"
            size={{xs: 12, sm: 12, md: 12}}
            sx={{}}>
            <Grid
                container
                justifyContent="flex-start"
                alignItems="flex-start"
                size={{xs: 12, sm: 12, md: 12}}
                sx={{
                    px: 3,
                    py: 6,
                    marginX: sCell ? 0 : 2,
                    maxWidth: "1400px",
                    backgroundColor: theme.palette.primary.main,
                    borderRadius: 4,
                    gap: {xs: 4, sm: 0, md: 0}

                }}
            >
                <Grid container size={{xs: 12, sm: 12, md: 2}} justifyContent={'center'} sx={{pr: 2}}>
                    <img src={logo_barra} width={150} height={'auto'}/>
                </Grid>


                <Grid container size={{xs: 12, sm: 6, md: 7}}>
                    <Stack>

                        <Grid container size={{xs: 12, sm: 12, md: 12}}>
                            <Typography
                                sx={{
                                    paddingBottom: 2,
                                    color: '#fff',
                                    fontSize: {xs: 32, md: 24},
                                    fontWeight: 800,
                                    textAlign: {xs: 'center', md: 'left'}
                                }}>
                                Categorias
                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}>


                                {cData.categorias.map((it, index) => {
                                    return (
                                        <Grid container size={{xs: 12, sm: 12, md: 6}}>
                                            <Tarjeta_Categoria_Footer item={it} seleccionado={seleccionado}
                                                                      setSeleccionado={setSeleccionado}/>
                                        </Grid>
                                    )
                                })}

                            </Grid>
                        </Grid>

                    </Stack>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 3}} sx={{mt: 4}}>
                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'center'}
                        size={12}
                        sx={{paddingTop: {sx: 4, sm: 10, md: 0}}}>
                        <Button
                            disableElevation
                            onClick={() => iniciarChatWass(NUMEROATENCION)}
                            color={'white'}
                            sx={{
                                fontSize: 24,
                                fontWeight: 800,
                                color: theme.palette.primary.main,
                                background: theme.palette.success.main,
                                borderRadius: 4,
                                paddingY: '4px',
                            }}>
                            ESCRÍBENOS
                        </Button>
                        <Grid container
                              justifyContent={'center'}
                              alignItems={'center'}
                              paddingTop={2}
                              size={{xs: 12, sm: 12, md: 12}}>
                            {REDES.map((red, index) => (
                                <Link key={index} target="_blank" rel="noopener"
                                      onClick={() => irUrl(red.url)}
                                      sx={{cursor: 'pointer',}}>
                                    <img src={red.imagen} alt={red.alt} style={{margin: '0 14px'}} width={30}/>
                                </Link>
                            ))}
                        </Grid>
                    </Grid>
                </Grid>

            </Grid>
        </Grid>
    )

}
export default Footer
